import { Loader } from "@progress/kendo-react-indicators";
import { createPortal } from "react-dom";

import type { LoaderProps } from "@progress/kendo-react-indicators";

import "./LoadingPanel.scss";

interface LoadingPanelProps extends LoaderProps {
  selector?: string;
}

export const LoadingPanel = ({
  selector,
  className,
  ...otherLoaderProps
}: LoadingPanelProps): JSX.Element => {
  const loadingPanel: JSX.Element = (
    <div className="k-loading-mask tc-loader">
      <span className="k-loading-text">Loading...</span>
      {otherLoaderProps.type ?
        <Loader className={`${className || ""} tc-loader-canvas`} {...otherLoaderProps} />
      : <div className="k-loading-image" />}
      <div className="k-loading-color" />
    </div>
  );

  // find by selector if provided, prefer grid child first & fallback to selector only
  if (selector) {
    const content = document.querySelector(`${selector} .k-grid-content, ${selector}`);
    if (content) {
      return createPortal(loadingPanel, content);
    }
  }

  // NOTE: with lazy loading this will:
  // * find a .contents-wrapper,
  // * start loading the lazy module,
  // * try to insert the portal content into a DOM element that no longer exists (blank instead of loading indicator)
  // * but removing the portal and falling on the return as-is works consistently
  // fallback to page/content wrapper
  // const pageTarget = document.querySelector('.page, .contents-wrapper');
  // if (pageTarget) {
  //   return ReactDOM.createPortal(loadingPanel, pageTarget);
  // }

  // finally return as-is
  return loadingPanel;
};
